module.exports = __webpack_public_path__ + "img/basketball.49b6e6f.svg";